module.exports = __webpack_public_path__ + "img/Most-Improved@2x.5cb22836.png";